import { useEffect } from 'react';

import { StepProps } from '@betterment/js-runtime';
import { SuccessFullScreen } from '@betterment/samba-react';

import { navigate } from '~/b4b/utils/pathHelpers';

export const SuccessStep: React.FC<StepProps> = ({ flowState }) => {
  // A temporary hack until we reactify the footer. On a success screen like this
  // we really don't need/want the footer so we just remove it. Should be removed
  // once we have the footer as part of our react layouts
  useEffect(() => {
    document.querySelector('footer')!.setAttribute('style', 'display:none !important');
    return () => {
      document.querySelector('footer')!.setAttribute('style', 'display:initial');
    };
  }, []);

  return <SuccessFullScreen message="Generating report" onCompletion={() => navigate(flowState.returnToPath)} />;
};
